
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 4h1.377L6.83 7.548h.062L8.347 4h1.376v5.28H8.641V5.843h-.044L7.23 9.254h-.737L5.127 5.83h-.044v3.45H4V4zm7.263 5.28h-1.196L11.889 4h1.439l1.82 5.28h-1.196l-.391-1.204h-1.906l-.392 1.204zm1.366-4.073l.649 1.998h-1.34l.65-1.998h.041zm4.976.593L16.54 4h-1.266l1.622 2.64-1.653 2.64h1.279l1.083-1.802h.04L18.73 9.28h1.284l-1.648-2.64L19.977 4h-1.261l-1.07 1.8h-.041zm-5.916 13.33c.21.307.733.307.942 0l3.295-4.839c.21-.307-.052-.691-.47-.691H8.864c-.418 0-.68.384-.47.691l3.295 4.839z"}})])
          )
        }
      }
    